export interface GetKeeValueSubscriptionAccessResponse {
  status: EKeeValueSubscriptionStatus;
}

export interface StartNewKeeValueSubscriptionIntegrationResponse {
  url: string;
  requestId: string;
}

export interface StartNewKeeValueCalculationResponse {
  url: string;
}

export enum EKeeValueSubscriptionStatus {
  NOT_CONNECTED = 'NOT_CONNECTED',
  VALID = 'VALID',
  INVALID = 'INVALID',
  MISSING_MODULE = 'MISSING_MODULE',
}
